import React from 'react';

const MultiMonitorIcon = ({ color = 'currentColor', style, ...rest }) => {
  const id = React.useId().replace(/:/g, '');
  const backscreen = `backscreen${id}`;
  const sep = `sep${id}`;
  const frontscreen = `frontscreen${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={style}
      {...rest}
    >
      <defs>
        <mask id={backscreen}>
          <rect x="18" y="4" width="42" height="31" rx="4" fill="#fff"/>
          <rect x="24" y="10" width="30" height="19" rx="2" fill="#000"/>
        </mask>
        <mask id={sep}>
          <rect width="64" height="64" fill="#fff"/>
          <rect x="-1" y="15" width="46" height="37" rx="7" fill="#000"/>
        </mask>
        <mask id={frontscreen}>
          <rect x="2" y="18" width="42" height="31" rx="4" fill="#fff"/>
          <rect x="8" y="24" width="30" height="19" rx="2" fill="#000"/>
        </mask>
      </defs>
      <g mask={`url(#${sep})`}>
        <rect x="18" y="4" width="42" height="31" rx="4" fill={color} mask={`url(#${backscreen})`}/>
      </g>
      <rect x="2" y="18" width="42" height="31" rx="4" fill={color} mask={`url(#${frontscreen})`}/>
      <rect x="14" y="52" width="18" height="5" rx="2.5" fill={color}/>
    </svg>
  );
};

export default MultiMonitorIcon;
